import AsnStore from "../../../stores/AsnStore";
import AsnDetailStore from "../../../stores/AsnDetailStore";
import DomainStore from "../../../stores/CmrDomainStore";
import ServiceStore from "../../../stores/CmrServiceStore";
import ProductItemSTore from "../../../stores/ProductItemStore";
import _ from "underscore";


export default function calcSubTotalServicesForAsnId(asnId){
  let total = 0;
  const asn = AsnStore.getData()[asnId];
  const asnDetailGroups = AsnDetailStore.groupBySku(AsnStore.getAsnDetails(asn));

  _(asnDetailGroups).map(calcForEachAsnDetailGroup);

  const services = ServiceStore.getServicesViaAsnId(asnId);

  _(services).map(calcForServiceFunc(1));


  function calcForEachAsnDetailGroup(asnDetailGroup){
    const firstDupSkuAsnDetail = asnDetailGroup[0];
    const services = ServiceStore.getServicesViaAsnDetailId(firstDupSkuAsnDetail.id);
    const quantity = AsnDetailStore.calcTotalQuantityForDetails(asnDetailGroup);
    _(services).map(calcForServiceFunc(quantity));

  }
  function calcForServiceFunc(quantity){
    return (service)=>{
      const domain = DomainStore.getData()[service.cdm_id];
      if(domain){
        total += DomainStore.getValue(domain) * quantity;
      }
      else{
        console.log("missing domain!");
      }
    }
  }



  return total;
}


// WEBPACK FOOTER //
// ./src/pages/asns/businessLogic/calcSubTotalServicesForAsnId.js